// Cart

<template>
  <div class="page-container justify-center pt-4 pb-5">
    <form
      id="lms5030"
      class="app-form white border-main curved-1 shadow-dark"
      @submit.prevent
    >
      <div class="px-3 pb-3">
        <div
          class="d-flex justify-between align-items-center lams p-2 curved-bottom mb-1"
          v-if="!isPaid"
        >
          <p class="mb-0 display-8 serif py-1">
            <i class="fa fa-shopping-cart fa-fw fa-lg mr-2"></i>Cart
          </p>
        </div>

        <div
          class="d-flex justify-between align-items-center success p-2 curved-bottom mb-1"
          v-if="isPaid"
        >
          <p class="mb-0 display-9 py-1">Payment Complete</p>
        </div>

        <!-- PayMaya sandbox - comment out before deployment -->
        <!-- <div class="buttons mt-3">
        <button type="button" class="info-light shadow sm-2 border-main text-center mb-3" @click="onListHooks"><i class="fa fa-list-ul fa-lg mr-2"></i>List Hooks</button>
        <button type="button" class="danger-light shadow sm-2 border-main text-center mb-3" @click="onDeleteHooks"><i class="fa fa-times fa-lg mr-2"></i>Delete Hooks</button>
        <button type="button" class="success-light shadow sm-2 border-main text-center mb-3" @click="onRegisterHooks"><i class="fa fa-edit fa-lg mr-2"></i>Register Hooks</button>
      </div> -->
        <!-- PJN -->
        <sym-alert
          class="success-light lg-2 mt-3"
          icon="check-circle"
          v-show="isPaid"
        >
          <p>Payment received. Thank you.</p>
          <p>
            You may now go to
            <sym-link to="lms5040">My Downloads</sym-link> page to access your
            requested file(s).
          </p>
        </sym-alert>

        <div class="details mt-3" v-show="!isPaid">
          <div class="mb-2" v-show="cart.length">
            <p class="bold display-8 mb-1">
              Order Review
              <span class="lg-3">( {{ cart.length }} item/s )</span>
            </p>
          </div>

          <table v-show="cart.length">
            <thead>
              <tr class="lams-light text-charcoal">
                <th class="doc-name">Document</th>
                <th class="doc-price text-right">Price</th>
                <th class="doc-remove"></th>
              </tr>
            </thead>

            <tbody class="white text-charcoal">
              <tr v-for="(item, index) in cart" :key="index">
                <td>{{ item.imageTypeName }}</td>
                <td class="text-right">
                  {{ core.toDecimalFormat(item.price) }}
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="primary-light border-main px-2"
                    title="Remove item"
                    @click="onToggleItemSelection(item)"
                  >
                    <i class="fa fa-remove"></i>
                  </button>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr class="text-right beige text-charcoal bold">
                <td>
                  <div class="d-flex justify-between display-8">
                    <span>Total</span>
                    <span><small>PHP</small></span>
                  </div>
                </td>
                <td class="display-8">{{ core.toDecimalFormat(amountDue) }}</td>
              </tr>
            </tfoot>
          </table>

          <div class="d-flex justify-end" v-if="hasItem">
            <button
              type="button"
              class="primary-light border-main text-center lg-2 mr-2 fw-30"
              :disabled="!hasItem"
              @click="removeAll()"
            >
              Remove All
            </button>
            <button
              type="button"
              class="success text-center lg-2 fw-30"
              :disabled="!hasItem"
              @click="onRequestCheckout"
            >
              Pay Now
            </button>
          </div>

          <sym-alert
            class="success-light lg-2 mt-1 mb-1"
            icon="info-circle"
            v-show="!cart.length"
          >
            <p class="lg-3 mb-0">Your cart is empty.</p>
          </sym-alert>
        </div>

        <button
          type="button"
          class="primary mb-2 mt-3 w-100 text-center lg-2 p-1 shadow-soft"
          @click="goBack"
        >
          <i class="fa fa-arrow-left mr-2"></i>Back
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { get, ajax } from "../../js/http";

import {
  getPaymentQueueId,
  createCheckout,
  // getWebhooks,
  // deleteWebhook,
  // registerWebhook
} from "../../js/dbPay";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms5030",

  data() {
    return {
      cart: [],
      cartKey: "",
      regionId: 4,
      amountDue: 0,
      trxTypeId: 1, // Document Download
      dlsdId: 0,
      queueId: 0,
      isPaid: false,
    };
  },

  computed: {
    hasItem() {
      return this.cart.length > 0;
    },
  },

  methods: {
    getTargetPath() {
      const me = this,
        q = {};

      if (me.regionId) {
        q.regionId = me.regionId;
      }

      if (me.queueId) {
        q.queueId = me.queueId;
      }

      return {
        name: me.$options.name,
        query: q,
      };
    },

    syncValues(p, q) {
      const me = this;

      let queueId = 0;

      if ("regionId" in q) {
        me.regionId = parseInt(q.regionId);
      } else {
        if ("regionId" in p) {
          me.regionId = parseInt(p.regionId);
        } else {
          me.regionId = 0;
        }
      }

      if ("queueId" in q && me.core.isInteger(q.queueId)) {
        queueId = parseInt(q.queueId);
        me.queueId = queueId;
      }
    },

    loadData() {
      const me = this;

      me.getLocalStorage();
      me.calculateTotal();
      me.replaceUrl();
    },

    getLocalStorage() {
      const me = this;

      let info = me.getLocalItem(me.cartKey);

      if (info) {
        me.cart = info;
      }
    },

    onToggleItemSelection(item) {
      const me = this,
        index = me.cart.findIndex(
          (obj) =>
            obj.imageId === item.imageId &&
            obj.entityId === item.entityId &&
            obj.datasourceId === item.datasourceId
        );

      if (index > -1) {
        me.cart.splice(index, 1);
      }

      me.removeLocalItem(me.cartKey);
      me.setLocalItem(me.cartKey, me.cart);
      me.calculateTotal();
    },

    calculateTotal() {
      const me = this;

      let total = 0;
      me.cart.forEach((item) => {
        total += item.price;
      });
      me.amountDue = total;
    },

    removeAll() {
      const me = this;

      me.cart = [];
      me.removeLocalItem(me.cartKey);
      me.isCartModalVisible = false;
      me.calculateTotal();
    },

    // API calls

    enListClient() {
      const me = this,
        options = me.core.getAjaxOptions("POST");

      return ajax(
        "api/accounts/" + me.accountCode + "/regions/" + me.regionId,
        options
      );
    },

    getAccountInfo() {
      return get("api/accounts/" + this.accountCode);
    },

    getPayQueue() {
      return get("api/rgn/" + this.regionId + "/payqueues/" + this.queueId);
    },

    // event handlers

    onRequestCheckout() {
      const me = this,
        wait = me.wait();

      me.getAccountInfo()
        .then((acct) => {
          me.accountInfo = acct[0];

          let payInfo = {
            regionId: me.regionId,

            amount: me.amountDue,
            trxTypeId: me.trxTypeId,
            dlsdId: me.dlsdId,
            documentList: JSON.stringify(me.cart),

            accountId: me.accountId,
            accountName: me.accountInfo.accountName,
            email: me.accountInfo.email,
            phoneNumber: me.accountInfo.phoneNumber,
            address: me.accountInfo.address,
            accountTypeId: me.accountTypeId,
            accountCode: me.accountCode,
          };

          return getPaymentQueueId(payInfo);
        })
        .then((queueId) => {
          if (queueId) {
            // use query string to hold issued queueId, just before redirection to PayMaya page
            me.queueId = queueId;
            me.replaceUrl();

            let checkoutInfo = {
              regionId: me.regionId,
              queueId: queueId,
              lastName: me.accountInfo.lastName,
              firstName: me.accountInfo.firstName,
              middleName: me.accountInfo.middleName,
              amountDue: me.amountDue,
            };

            return createCheckout(checkoutInfo);
          }
        })
        .then((newCheckout) => {
          me.stopWait(wait);

          if (newCheckout) {
            window.location.href = newCheckout.redirectUrl;
          }
        })
        .catch((fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        });
    },

    // onListHooks () {
    //   getWebhooks()
    //     .then( hooks => {
    //       if (hooks && hooks.length) {
    //         // console.log(hooks);
    //       }
    //     });
    // },

    // onRegisterHooks () {
    //   registerWebhook('PAYMENT_SUCCESS')
    //     .then( () => {
    //       return registerWebhook('PAYMENT_FAILED');
    //     })
    //     .then( () => {
    //       return registerWebhook('PAYMENT_EXPIRED');
    //     });
    // },

    // onDeleteHooks () {
    //   getWebhooks()
    //     .then( hooks => {
    //       if (hooks && hooks.length) {
    //         hooks.forEach(hook => {
    //           if (hook.name === 'PAYMENT_SUCCESS') {
    //             deleteWebhook(hook.id);
    //           }
    //           if (hook.name === 'PAYMENT_FAILED') {
    //             deleteWebhook(hook.id);
    //           }
    //           if (hook.name === 'PAYMENT_EXPIRED') {
    //             deleteWebhook(hook.id);
    //           }
    //         });
    //       }
    //     });
    // }
  },

  created() {
    this.accountId = 0;
    this.accountTypeId = 0;
    this.accountCode = "";
    this.accountInfo = {}; // used as part of payload when requesting checkout
  },

  mounted() {
    const me = this,
      userInfo = me.sym.userInfo;

    me.accountId = userInfo.accountId;
    me.accountTypeId = userInfo.accountTypeId;
    me.accountCode = userInfo.accountCode;

    me.syncValues(me.params, me.query); // loads queueId from query string if any is set by payment attempt

    me.cartKey = me.sym.userInfo.accountCode + "*" + me.regionId + "*CART";

    me.loadData();

    if (me.queueId) {
      me.getPayQueue()
        .then((info) => {
          if (info && info.length) {
            if (info[0].payStatusId === 1) {
              me.isPaid = true;
              me.cart = [];
              me.removeLocalItem(me.cartKey);
              return me.enListClient();
            } else {
              return Promise.resolve();
            }
          }
        })
        .then(() => {})
        .catch((fault) => {
          me.showFault(fault);
        });

      // remove queueId in URL
      me.queueId = 0;
      me.replaceUrl(); // framework calls getTargetPath() automatically
    }
  },
};
</script>

<style scoped>
.page-container {
  display: flex;
}

.app-form {
  width: 42%;
}

.details {
  padding: 0.5rem;
}

.doc-name {
  width: 65%;
}

.doc-price {
  width: 25%;
}

.doc-remove {
  width: 10%;
}

.alert.fade-enter-active {
  transition: opacity 1s;
}

.alert.fade-leave-active {
  transition: opacity 0.5s;
}

@media (max-width: 1024px) {
  .app-form {
    width: 60%;
  }
}

@media (max-width: 640px) {
  .app-form {
    width: 90%;
  }
}

@media (max-width: 480px) {
  .app-form {
    width: 96%;
  }

  .doc-name {
    width: 55%;
  }

  .doc-price {
    width: 30%;
  }

  .doc-remove {
    width: 15%;
  }
}

@media (max-width: 360px) {
  .details {
    padding: 0.125rem;
  }
}

@media (max-width: 320px) {
  .app-form {
    width: 98%;
  }

  .details {
    padding: 0;
  }

  .doc-name {
    width: 44%;
  }

  .doc-price {
    width: 38%;
  }

  .doc-remove {
    width: 18%;
  }
}
</style>
